// app/frontend/entrypoints/public/main.js
import { createApp, watch } from 'vue'
import AppPublic from '../public/pages/AppPublic.vue'
import { publicRouter } from './router'
import { createPinia } from 'pinia'
import i18n from '../public/plugins/i18n'   // ✅ единый экземпляр
import { useLanguageStore } from '@/stores/languageStore'
import axios from 'axios'

// 1️⃣ Создаём приложение и подключаем Pinia
const app = createApp(AppPublic)
const pinia = createPinia()
app.use(pinia)

// 2️⃣ Инициализируем стор языка
const languageStore = useLanguageStore()

// 🌍 Определяем домен и локаль
const domain = window.location.hostname
const savedLocale = localStorage.getItem('locale')
const savedCountry = localStorage.getItem('country')

// 🌍 Устанавливаем дефолты при первом визите
if (!savedLocale && domain.includes('estimei.com')) {
  // 🇲🇩 Локальный молдавский портал
  localStorage.setItem('locale', 'ro')
  localStorage.setItem('country', 'moldova')
  languageStore.locale = 'ro'
  languageStore.country = 'moldova'
} else {
  // 🌍 По умолчанию — русский и глобальный контекст
  languageStore.locale = savedLocale || 'ru'
  languageStore.country = savedCountry || 'global'
}

// 3️⃣ Применяем язык к глобальному i18n
i18n.global.locale.value = languageStore.locale

// 4️⃣ Монтируем приложение
app.use(i18n)
app.use(publicRouter)
app.mount('#vue-root')

// 5️⃣ Реактивное обновление языка при переключении
watch(
  () => languageStore.locale,
  (newLocale) => {
    i18n.global.locale.value = newLocale
    localStorage.setItem('locale', newLocale)
  }
)

// 6️⃣ Добавляем заголовки для API-запросов
axios.defaults.headers.common['X-Locale'] = languageStore.locale
axios.defaults.headers.common['X-Country'] = languageStore.country
